// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingDots_container__XO_Fu","dot":"LoadingDots_dot__XXd8a","wave":"LoadingDots_wave__yoRiP"};